import useGetOfferTechnologies from './useGetOfferTechnologies'

export default useGetOfferTechnologies
